import { alpha, Box, styled, useMediaQuery } from "@mui/material";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";

export const StyledBox = styled(Box)(({ theme }) => {
  const { colors } = useMUIThemeModeContext();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return {
    backgroundColor: alpha(colors.gray450, 0.1),
    borderRadius: "10px",
    padding: isMobile ? theme.spacing(2) : theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  };
});
